import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import axiosInstance from "../../api/axiosInstance";
import { delay } from "../../helper/delayresponse";

export interface UserLogsReports {
    id: number;
    name: string
    UserEmail: string;
    UserName?: string;
    IP_Address?: string;
    Module?: string;
    Description?: string;
    createdAt?: string;
}

interface UserLogsReportsState {
    userlogsreportdata: UserLogsReports[];
    info: { count: number; current_page: number; limit: number; total_page: number } | null;
    error: string | null;
    loading: boolean;
}

interface UserLogsReportsParams {
    // id: number;
    limit: number;
    page: number;
    user_id: number | undefined;
    module_name: string;
    ip_address?: string;
    from_date: string;
    to_date: string;
}

interface UserLogsReportsResponse {
    data: UserLogsReports[];
    info: {
        count: number;
        current_page: number;
        limit: number;
        total_page: number;
    };
}

export const GetallUserLogsReports = createAsyncThunk<
    UserLogsReportsResponse,
    UserLogsReportsParams,
    { rejectValue: string }
>(
    'GetallUserLogsReports',
    async (params, { rejectWithValue }) => {
        const {
            user_id,
            module_name,
            ip_address,
            from_date,
            to_date,
            page,
            limit,
        } = params; // Destructure `params` to extract the required values

        try {
            await delay(500);
            const response = await axiosInstance.get(`/api/admin/reports/user-logs`, {
                params: {
                    user_id,
                    module_name,
                    ip_address,
                    from_date,
                    to_date,
                    page,
                    limit,
                },
            });
            return { data: response.data.Logs, info: response.data.info };
        } catch (error: any) {
            if (error.response && error.response.data) {
                return rejectWithValue(error.response.data);
            }
            return rejectWithValue(error.message);
        }
    }
);


const initialState: UserLogsReportsState = {
    userlogsreportdata: [],
    info: null,
    error: null,
    loading: false,
};

const userlogsreportsSlice = createSlice({
    name: "Userlogsreport",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            // ===============get-all-user-logs-slice-start============
            .addCase(GetallUserLogsReports.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(GetallUserLogsReports.fulfilled, (state, action: PayloadAction<{ data: UserLogsReports[], info: { count: number; current_page: number; limit: number; total_page: number } }>) => {
                state.loading = false;
                state.userlogsreportdata = action.payload.data;
                state.info = action.payload.info;
            })
            .addCase(GetallUserLogsReports.rejected, (state, action: PayloadAction<string | undefined>) => {
                state.loading = false;
                state.error = action.payload || 'An error occurred';
            });
        // ===============get-all-user-logs-end============
    },
});

export default userlogsreportsSlice.reducer;
